import { Search, Loader, X } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface ApogeePackCatalogSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  /** Reflects parent fetch in progress (e.g. debounced search running). */
  loading?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  /** Show a subtle hint under the bar */
  hint?: string;
}

/**
 * Styled search input for the modpack catalog (`GET /v1/search/packs`).
 * Pairs with debounced query state in the parent (see ModpackBrowserView).
 */
export function ApogeePackCatalogSearchBar({
  value,
  onChange,
  loading = false,
  disabled = false,
  placeholder = 'Search by name, slug, summary, platforms, versions…',
  className,
  hint = 'Powered by Apogee full-text search (name boosted).',
}: ApogeePackCatalogSearchBarProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <div className="relative">
        <Search
          className={cn(
            'absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none',
            value.trim() ? 'text-accent-300' : 'text-glass-400'
          )}
        />
        {loading && (
          <Loader className="absolute right-10 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-accent-300 pointer-events-none" />
        )}
        <input
          type="search"
          autoComplete="off"
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="glass-input w-full pl-9 pr-10"
        />
        {value && !disabled && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="btn-icon btn-icon-sm absolute right-1.5 top-1/2 -translate-y-1/2"
            aria-label="Clear search"
            title="Clear search"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      {hint && <p className="text-[11px] text-glass-500 px-0.5">{hint}</p>}
    </div>
  );
}
